export default __webpack_public_path__ + "static/media/86.758bc746.png";